// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b2b-lib-loading{padding:0;z-index:100000;position:absolute;left:0;top:0;background:rgba(255,255,255,0.2);height:100%;width:100%}.b2b-lib-loading .b2b-lib-loadingBar{height:3px;background:#e40000;box-shadow:0px 0px 20px #e400008c;width:95%;animation-name:b2b-lib-LoaderPr;animation-duration:2s}.b2b-lib-loading.b2b-lib-hide{display:none !important}@keyframes b2b-lib-LoaderPr{0%{width:0px}30%{width:80%}50%{width:90%}100%{width:95%}}\n", ""]);
// Exports
exports.locals = {
	"loading": "b2b-lib-loading",
	"loadingBar": "b2b-lib-loadingBar",
	"LoaderPr": "b2b-lib-LoaderPr",
	"hide": "b2b-lib-hide"
};
module.exports = exports;
